import {
  Configs,
  RatingCategories,
} from '../interfaces/WidgetConfigs.interface';

export const checkIsPositiveRating = (value: number): boolean => value >= 4;

export const getRatingCategoryConfig = (
  value: number,
  widgetConfig: Configs,
): RatingCategories => {
  const {
    rating: { negativeCategories, positiveCategories },
  } = widgetConfig;

  if (checkIsPositiveRating(value)) {
    return positiveCategories;
  }

  return negativeCategories;
};
